<template>
	<div ref="container" style="width: 100%; height: 100%; position: relative; overflow: hidden;"></div>
</template>

<script>
import EmoteWallWidget from '@/widgets/EmoteWallWidget';
import 'animate.css/animate.min.css';

const PREVIEW_EMOJIS = ['😀', '😂', '🔥', '💯', '❤️', '🎉', '👍', '🤣', '😍', '🥳', '✨', '🎊', '😎', '🚀', '🌈'];

const mockApi = {
	get(path) {
		if(path.includes('/settings/')) return Promise.resolve({});
		if(path.includes('/giftTypes')) return Promise.resolve({ results: [] });
		return Promise.resolve({});
	},
	post() { return Promise.resolve(); },
};
const mockSocket = { subscribe() { return 0; }, unsubscribe() {} };

function pickRandom(arr) {
	return arr[Math.floor(Math.random() * arr.length)];
}

export default {
	name: 'EmoteWallWidgetPreview',
	props: {
		settings: { type: Object, default: () => ({}) },
	},
	watch: {
		settings: {
			deep: true,
			handler(s) { this._applySettings(s); },
		},
	},
	mounted() {
		this._initWidget();
	},
	beforeDestroy() {
		this._stopPreview();
		this._destroyWidget();
	},
	methods: {
		async _initWidget() {
			this.widget = new EmoteWallWidget({
				container: this.$refs.container,
				api: mockApi,
				socket: mockSocket,
				hash: 'preview',
				baseUrl: this.$baseUrl,
			});
			await this.widget.init();
			this._applySettings(this.settings);
			this._startPreview();
		},
		_destroyWidget() {
			if(this.widget) {
				this.widget.destroy();
				this.widget = null;
				if(this.$refs.container) this.$refs.container.innerHTML = '';
			}
		},
		_applySettings(s) {
			if(!this.widget) return;
			this.widget.applySettings({ ...s });
		},
		_startPreview() {
			const schedule = () => {
				this._spawnFakeEmotes();
				this._previewTimeoutId = setTimeout(schedule, 1200 + Math.random() * 1500);
			};
			this._previewTimeoutId = setTimeout(schedule, 400);
		},
		_stopPreview() {
			if(this._previewTimeoutId) {
				clearTimeout(this._previewTimeoutId);
				this._previewTimeoutId = null;
			}
		},
		_spawnFakeEmotes() {
			if(!this.widget?.settings) return;
			const count = 1 + Math.floor(Math.random() * 4);
			const emotes = Array.from({ length: count }, () => ({
				emoji: pickRandom(PREVIEW_EMOJIS),
				type: 'emoji',
			}));
			this.widget.spawnEmotes(emotes);
		},
	},
};
</script>
